import { Container, Grid, Text, Anchor, Group, Stack, Divider, ThemeIcon } from '@mantine/core';
import { IconPhone, IconMail, IconMapPin } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer style={{ borderTop: '1px solid var(--mantine-color-dark-4)', marginTop: 80 }}>
      <Container size="lg" py={60}>
        <Grid>
          {/* Company Info */}
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Stack gap="xs">
              <Text fw={700} size="lg" c="white">CamGlass</Text>
              <Text size="sm" c="dimmed">
                Excellence in Glass Fabrication Since 1978
              </Text>
              <Group gap="xs">
                <ThemeIcon variant="subtle" color="gray" size="sm">
                  <IconMapPin size={14} />
                </ThemeIcon>
                <Text size="sm" c="dimmed">
                  3550 West Tacoma Street<br />
                  Broken Arrow, OK 74012
                </Text>
              </Group>
              <Group gap="xs">
                <ThemeIcon variant="subtle" color="gray" size="sm">
                  <IconPhone size={14} />
                </ThemeIcon>
                <Anchor href="tel:9182546000" size="sm" c="dimmed">
                  918.254.6000
                </Anchor>
              </Group>
              <Group gap="xs">
                <ThemeIcon variant="subtle" color="gray" size="sm">
                  <IconMail size={14} />
                </ThemeIcon>
                <Anchor href="mailto:sales@camglass.com" size="sm" c="dimmed">
                  sales@camglass.com
                </Anchor>
              </Group>
            </Stack>
          </Grid.Col>

          {/* Quick Links */}
          <Grid.Col span={{ base: 6, md: 3 }}>
            <Stack gap="xs">
              <Text fw={700} size="sm" c="white" mb={4}>Quick Links</Text>
              {[
                ['Home', '/'],
                ['Our Capabilities', '/solutions'],
                ['Request Quote', '/request-quote'],
                ['In Action', '/in-action'],
                ['Careers', '/join-us'],
                ['Contact', '/contact'],
              ].map(([label, href]) => (
                <Anchor
                  key={href}
                  component="span"
                  size="sm"
                  c="dimmed"
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate(href)}
                >
                  {label}
                </Anchor>
              ))}
            </Stack>
          </Grid.Col>

          {/* Services */}
          <Grid.Col span={{ base: 6, md: 2 }}>
            <Stack gap="xs">
              <Text fw={700} size="sm" c="white" mb={4}>Services</Text>
              {[
                ['Tempered Glass', '/solutions/tempered-glass'],
                ['OEM Assemblies', '/solutions/oem'],
                ['3PL Logistics', '/solutions/3pl'],
                ['Custom Engineering', '/our-story/engineering'],
              ].map(([label, href]) => (
                <Anchor
                  key={href}
                  component="span"
                  size="sm"
                  c="dimmed"
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate(href)}
                >
                  {label}
                </Anchor>
              ))}
            </Stack>
          </Grid.Col>

          {/* Certifications */}
          <Grid.Col span={{ base: 12, md: 3 }}>
            <Stack gap="xs">
              <Text fw={700} size="sm" c="white" mb={4}>Certifications</Text>
              <Text size="xs" c="dimmed">ISO 9001:2015 Certified</Text>
              <Text size="xs" c="dimmed">DOT · ECE · EEC · CCC · SGCC</Text>
              <Text size="xs" c="dimmed">Veteran-Owned Small Business</Text>
              <Divider my="xs" />
              <Text size="xs" c="dimmed">
                © {new Date().getFullYear()} Cameron Glass. All rights reserved.
              </Text>
            </Stack>
          </Grid.Col>
        </Grid>
      </Container>
    </footer>
  );
}
